import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/69bd92d67d947e0014e4882f/nexsys/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69bd92d67d947e0014e4882f/nexsys/src/components/BenefitsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69bd92d67d947e0014e4882f/nexsys/src/components/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69bd92d67d947e0014e4882f/nexsys/src/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69bd92d67d947e0014e4882f/nexsys/src/components/Navbar.tsx");
